"use strict";

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            availableRooms: "=",
            selectedRoom: "=",
            selectedBedId: "=",
            loadingRoomsAndBeds: "="
        },
        controller: "residentRoomAssignment.controller",
        controllerAs: "vm",
        replace: false,
        templateUrl: "app/common/directives/partials/residentRoomAssignment.html"
    };
}